import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import Dentistry from './Dentistry';

export default function Blog() {
  return (
    <>
        <Navbar />
        <Dentistry />
        <Footer />
        <Copyright />
    </>
  )
}